import React from 'react';
import Appicon from '../coreComponent/Appicon';

export default class ReportHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      image: require('../Assets/report-images/user-background.png').default
    };
  }

  render() {
    return (
      <div>
        <div className={'user-background'}>
          <img src={this.state.image} />
        </div>
        <div className={'user-content'}>
          <div className={'user-profile-img'}>
            <div
              className={
                this.props.selfieUrl === require('../Assets/report-images/user-icon.png').default
                  ? 'user-profile-img-background'
                  : ''
              }
            >
              <img src={this.props.selfieUrl} />
            </div>
          </div>
          {this.props.verfiedStatus === 'failed' ? (
            <div className={'label failed-verification'}>
              <div className={'verified-icon'}>
                <Appicon iconCls={'failed-verification'} />
              </div>
              <div className={'title'}>{'FAILED VERIFICATION'}</div>
            </div>
          ) : this.props.verfiedStatus === 'verified' ? (
            <div className={'label verified-label'}>
              <div className={'verified-icon'}>
                <Appicon iconCls={'verified'} />
              </div>
              <div className={'title'}>{'VERIFIED'}</div>
            </div>
          ) : this.props.verfiedStatus === 'unverified' ? (
            <div className={'label unverified-verification'}>
              <div className={'verified-icon'}>
                <Appicon iconCls={'unverified'} />
              </div>
              <div className={'title'}>{'UNVERIFIED'}</div>
            </div>
          ) : (
            <div></div>
          )}

          <div className={'user-name'}>
            <div className={'name'}>{this.props.personName}</div>
            <div className={'doc-type'}>{this.props.docType}</div>
          </div>
        </div>
      </div>
    );
  }
}

ReportHeader.defaultProps = {
  selfieUrl: null,
  verfiedStatus: null,
  personName: null,
  docType: null
};
